import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { axiosInstance, axiosInstancePython } from "../../utils/axiosInstance";
import { ExternalApiEndPoint } from "../../api-routes";

const postGlobalTalentSearch = async (payload) => {
  return (await axiosInstancePython.post("search-resumes", payload)).data;
};

export const useGlobalTalentSearch = () => {
  return useMutation({
    mutationFn: (payload) => postGlobalTalentSearch(payload),
  });
};

const GlobalTalentSearchQuery = async (payload) => {
  return (await axiosInstancePython.post("query-search-resumes", payload)).data;
};

export const useGlobalTalentSearchQuery = () => {
  return useMutation({
    mutationFn: (payload) => GlobalTalentSearchQuery(payload),
  });
};

const GlobalTalentSearchResumeDownload = async (resumeId) => {
  return (await axiosInstance.get(`api/element/resume/download-resume/${resumeId}`, {
    responseType: 'blob'
  })).data;
} 

export const useGlobalTalentSearchResumeDownload = () => {
  return useMutation({
    mutationFn: (resumeId) => GlobalTalentSearchResumeDownload(resumeId),
  });
};

const fetchCitiesByCountry = async (country) => {
  const response = await axios.post(ExternalApiEndPoint.COUNTRIES_CITIES, {
    country,
  });
  return response.data;
};

export const useFetchCitiesByCountry = () => {
  return useMutation({
    mutationFn: (country) => fetchCitiesByCountry(country),
  });
};
